import { render } from "./ImagePoster.vue?vue&type=template&id=eb7ca9ac&ts=true"
import script from "./ImagePoster.vue?vue&type=script&lang=ts"
export * from "./ImagePoster.vue?vue&type=script&lang=ts"

import "./ImagePoster.vue?vue&type=style&index=0&id=eb7ca9ac&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__